import React, {Component} from 'react';
import {Button, Col, FormGroup, Input, Label, Row, UncontrolledTooltip} from "reactstrap";
import NumberFormat from 'react-number-format';
import DefaultModal from "../../invoice/DefaultModal";
import Select from "../../../local_node_modules/react-select";
import {isValidVoucherModalData} from "../../../common/componentValidation";
import Alert from "react-s-alert";
import {Decimal} from "decimal.js";
import {listStocksFromVoucherModal} from "../../../helper/helper";
import StockModal from "../../stock/StockModal";

class VoucherModal extends Component {

    constructor(props) {
        super(props);
        this.props.selectedItem === null?
        this.state ={
            error:{},
            btnDisabled :false,
            itemName:"",
            hasStoppage:1,
            calculateType:0,
            stoppagePercentage:20,
            kdvPercentage:20,
            amount:0,
            brut:0,
            stoppageAmount:0,
            net:0,
            kdvAmount:0,
            tahsilEdilen:0,
            isManual:false,
            isManualResult:false,
            trdDocVoucherLines: [],
            checked:false,
            damgaVergisiPercentage:0,
            damgaVergisiAmount:0,
            stocksList:null,
        }
        :
            this.state ={
                error:{},
                btnDisabled :false,
                itemName:this.props.selectedItem.data.itemName,
                hasStoppage:this.props.selectedItem.data.trdDocVoucherLineCharges[0].stoppageCode ==="000"?0:1,
                calculateType:0,
                stoppagePercentage:this.props.selectedItem.data.trdDocVoucherLineCharges[0].percentage,
                kdvPercentage:this.props.selectedItem.data.trdDocVoucherLineCharges[1].percentage,
                amount:this.props.selectedItem.data.lineExtensionAmount,
                brut:0,
                stoppageAmount:0,
                net:0,
                kdvAmount:0,
                tahsilEdilen:0,
                isManual:false,
                isManualResult:false,
                trdDocVoucherLines: [],
                checked:false,
                damgaVergisiPercentage:0,
                damgaVergisiAmount:0,
                stocksList:null,
            }



        this.validateMessage  = this.validateMessage.bind(this);
        this.onChange   = this.onChange.bind(this);
        this.clean      = this.clean.bind(this);
        this.calculate  = this.calculate.bind(this);
        this.createStock=this.createStock.bind(this);
        this.onStockChange=this.onStockChange.bind(this);
        this.arrowRenderer=this.arrowRenderer.bind(this);
        this.switchManualItemName=this.switchManualItemName.bind(this);
        this.setStocks=this.setStocks.bind(this);
        this.switchDamgaVergisi=this.switchDamgaVergisi.bind(this);
        this.listStocks=this.listStocks.bind(this);

    }

    componentDidMount() {
        this.listStocks();
    }

    onChange(e) {
        let {name, value} = e;
        if (name === "hasStoppage")
            this.setState({stoppagePercentage: (value === 0 ? 0 : 20)});

        this.setState({[name]: value});
    }

    arrowRenderer(e) {
        let onMouseDown = e.onMouseDown;
        return React.createElement('span', {
            className: 'search',
            onMouseDown: onMouseDown
        });
    }

    onStockChange(data) {
        let self = this;
        if (data.hasOwnProperty("stock")) {
            let stock=data.stock;
            let itemName=stock.name;
            let stoppagePercentage=stock.gvStoppageSell;
            let kdvPercentage=stock.kdvSell;
            let amount=stock.defPriceSell;
            let hasStoppage=(stoppagePercentage===0 ? 0 : 1);
            let calculateType=0;
            self.setState({itemName,stoppagePercentage,kdvPercentage,amount,hasStoppage,calculateType});
        }
    }

    switchDamgaVergisi(e){
        if(e.target.checked){
            this.setState({checked: e.target.checked, damgaVergisiPercentage:0, damgaVergisiAmount:0});
        }else{
            this.setState({checked: e.target.checked});
        }
    }

    switchManualItemName(e) {
        let self=this;
        self.setState({isManual: !e.target.checked});
        console.log("e",e,e.target.checked);
        let message = "";
        if (e.target.checked) {
            message = "Ürün/Hizmet Adı manuel giriş <strong style='font-weight: 100'>aktif</strong> hale getirildi.";
        } else {
            message = "Ürün/Hizmet Adı manuel giriş <strong style='font-weight: 100'>pasif</strong> hale getirildi.";
        }
        Alert.info(message, {
            position: 'top-right',
            effect: 'stackslide',
            timeout: 1000,
            html: true
        });
    }

    clean(){
        this.setState({
            btnDisabled :false,
            itemName:"",
            hasStoppage:1,
            calculateType:0,
            stoppagePercentage:20,
            kdvPercentage:20,
            amount:0,
            brut:0,
            stoppageAmount:0,
            net:0,
            kdvAmount:0,
            tahsilEdilen:0,
            checked:false,
            damgaVergisiPercentage:0,
            damgaVergisiAmount:0
        });
    }

    calculate(apply){
        let result = isValidVoucherModalData(this.state);
        let error = result.error;
        let valid = result.valid;
        if (valid) {
            let {
                hasStoppage,
                calculateType,
                stoppagePercentage,
                kdvPercentage,
                amount,
                itemName,
                brut,
                stoppageAmount,
                kdvAmount,
                net,
                tahsilEdilen,
                damgaVergisiPercentage,
                damgaVergisiAmount
            } = this.state;

            if(!apply || !this.state.isManualResult){
                brut = 0;
                stoppageAmount = 0;
                kdvAmount = 0;
                net = 0;
                tahsilEdilen = 0;
                damgaVergisiAmount = 0;

                if (hasStoppage === 1) {
                    if (calculateType === 0) {
                        brut = parseFloat(amount);
                        stoppageAmount = brut * (stoppagePercentage / 100);
                        kdvAmount = brut * (kdvPercentage / 100);
                        net = brut - stoppageAmount;
                        tahsilEdilen = parseFloat(net) + parseFloat(kdvAmount);
                    } else if (calculateType === 1 || calculateType === 5) {
                        net = amount;
                        brut = net / (1 - (stoppagePercentage / 100));
                        stoppageAmount = brut * (stoppagePercentage / 100);
                        kdvAmount = brut * (kdvPercentage / 100);
                        tahsilEdilen = parseFloat(net) + parseFloat(kdvAmount);
                    } else if (calculateType === 2) {
                        tahsilEdilen = amount;
                        brut = tahsilEdilen / (1 - (stoppagePercentage / 100) + (kdvPercentage / 100));
                        stoppageAmount = brut * (stoppagePercentage / 100);
                        kdvAmount = brut * (kdvPercentage / 100);
                        net = brut - stoppageAmount;
                    } else if (calculateType === 4) {
                        brut = amount / (1 - (stoppagePercentage / 100) + (kdvPercentage / 100));
                        kdvAmount = brut * (kdvPercentage / 100);
                        net = brut + kdvAmount;
                        stoppageAmount = brut * (stoppagePercentage / 100);
                        tahsilEdilen = net - stoppageAmount;
                    }
                } else if (hasStoppage === 0) {
                    if (calculateType === 0) {
                        brut = amount;
                        stoppageAmount = 0;
                        kdvAmount = brut * (kdvPercentage / 100);
                        net = brut - stoppageAmount;
                        tahsilEdilen = net + kdvAmount;
                    } else if (calculateType === 1 || calculateType === 5) {
                        net = parseFloat(amount);
                        brut = net;
                        stoppageAmount = 0;
                        kdvAmount = brut * (kdvPercentage / 100);
                        tahsilEdilen = net + kdvAmount;
                    } else if (calculateType === 2) {
                        tahsilEdilen = amount;
                        brut = tahsilEdilen / (1 + (kdvPercentage / 100));
                        stoppageAmount = 0;
                        kdvAmount = brut * (kdvPercentage / 100);
                        net = brut - stoppageAmount;
                    } else if (calculateType === 4) {
                        brut = amount / (1 + (kdvPercentage / 100));
                        kdvAmount = brut * (kdvPercentage / 100);
                        net = brut;
                        stoppageAmount = brut * (stoppagePercentage / 100);
                        tahsilEdilen = (net + kdvAmount) - stoppageAmount;
                    }
                }

                if (calculateType === 3) {
                    brut = amount / (1 + (kdvPercentage / 100));
                    stoppageAmount = brut * (stoppagePercentage / 100);
                    net = brut - stoppageAmount;
                    kdvAmount = brut * (kdvPercentage / 100);
                    tahsilEdilen = net + kdvAmount;
                } else if (calculateType === 6) {
                    brut = amount;
                    stoppageAmount = brut * (stoppagePercentage / 100);
                    net = brut - stoppageAmount;
                    kdvAmount = brut * (kdvPercentage / 100);
                    tahsilEdilen = net + kdvAmount;
                }
            }

            damgaVergisiAmount = new Decimal((new Decimal(brut).mul(new Decimal(damgaVergisiPercentage).div(new Decimal(1000)))).toFixed(2)).toNumber();
            if (!apply){
                tahsilEdilen =  new Decimal(new Decimal(tahsilEdilen).toFixed(3, Decimal.ROUND_HALF_UP)).toNumber();
                net =  new Decimal(new Decimal(net).toFixed(2, Decimal.ROUND_HALF_UP)).toNumber();
                if(itemName === 'Avukatlık Ücreti' || itemName === 'Arabuluculuk Ücreti') {
                    if (net === 894.91){
                        net = new Decimal(new Decimal(net).add(new Decimal(0.01))).toNumber()
                    }

                    if(net === 1342.38){
                        net = new Decimal(new Decimal(net).add(new Decimal(-0.01))).toNumber()
                    }
                }
                this.setState({brut, stoppageAmount, kdvAmount, net, tahsilEdilen, damgaVergisiAmount});
            }else{
                let trdDocVoucherLineCharges = [
                    {
                        recordId: null,
                        taxCode: {
                            recordId: 2,
                            code: "0003",
                            shortName: "GV STOPAJI",
                            longName: "GELİR VERGİSİ STOPAJI",
                            direction: -1,
                            calculatedBy: "AMOUNT",
                            priority: 2,
                            affectTaxableAmount: 1,
                            mm: 1,
                            smm: 1,
                            inv: 1,
                            isAffectKdv: 0
                        },
                        calculateBy: "AMOUNT",
                        calculateFrom: "stoppageCode",
                        percentage: stoppagePercentage,
                        amount: new Decimal(new Decimal(stoppageAmount).toFixed(2)).toNumber(),
                        direction: -1,
                        exemptionReasonCode: null,
                        exemptionReason: null,
                        perUnitAmount: 0,
                        calculatedBy: "AMOUNT",
                        taxableAmount:new Decimal(new Decimal(brut).toFixed(2)).toNumber(),
                        withholdingCode: null,
                        stoppageCode:(hasStoppage === 1 ? "022" :"000")
                    },
                    {
                        recordId: null,
                        taxCode: {
                            recordId: 1,
                            code: "0015",
                            shortName: "KDV GERCEK",
                            longName: "GERÇEK USULDE KATMA DEĞER VERGİSİ",
                            direction: 1,
                            calculatedBy: "AMOUNT",
                            priority: 4,
                            affectTaxableAmount: 0,
                            mm: 0,
                            smm: 1,
                            inv: 1,
                            isAffectKdv: 0
                        },
                        calculateBy: "AMOUNT",
                        calculateFrom: "percentage",
                        percentage: kdvPercentage,
                        amount: new Decimal(new Decimal(kdvAmount).toFixed(2)).toNumber(),
                        direction: 1,
                        exemptionReasonCode: null,
                        exemptionReason: null,
                        perUnitAmount: 0,
                        calculatedBy: "AMOUNT",
                        taxableAmount: new Decimal(new Decimal(brut).toFixed(2)).toNumber(),
                        withholdingCode: null
                    },
                    {
                        recordId: null,
                        taxCode: {
                            recordId: 6,
                            code: "9015",
                            shortName: "KDV TEVKİFATI",
                            longName: "KDV TEVKİFATI",
                            direction: -1,
                            calculatedBy: "AMOUNT",
                            priority: 5,
                            affectTaxableAmount: 0,
                            mm: 0,
                            smm: 1,
                            inv: 1,
                            isAffectKdv: 0
                        },
                        calculateBy: "AMOUNT",
                        calculateFrom: "percentage",
                        percentage: 0,
                        amount: 0,
                        direction: -1,
                        exemptionReasonCode: null,
                        exemptionReason: null,
                        perUnitAmount: 0,
                        calculatedBy: "AMOUNT",
                        taxableAmount: new Decimal(new Decimal(kdvAmount).toFixed(2)).toNumber(),
                        withholdingCode: "000"
                    }];

                let trdDocVoucherLines= [{
                    recordId: null,
                    itemId: null,
                    itemCode: null,
                    itemName: itemName,
                    quantity: 1,
                    unit: "C62",
                    unitPrice: new Decimal(new Decimal(brut).toFixed(2)).toNumber(),
                    lineExtensionAmount: new Decimal(new Decimal(brut).toFixed(2)).toNumber(),
                    note: null,
                    trdDocVoucherLineCharges: trdDocVoucherLineCharges
                }];

                let note ="";
                if(damgaVergisiPercentage){
                    note = "Damga Vergisi((Binde)"+this.currencyFormat(damgaVergisiPercentage)+"):" + this.currencyFormat(damgaVergisiAmount) + " TL ";
                }
                this.props.applyLine(trdDocVoucherLines,note);
            }
        }else{
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
            this.setState({error: error});
        }
    }

    currencyFormat(num) {
        return ((new Decimal(num).toFixed(2)).replace('.', ',')).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    createStock(option) {
        let stock = {
            alias: "",
            baseUnit: "C62",
            code: "",
            defPricePurchase: 1,
            defPriceSell: 1,
            defaultCurrencyCode: this.props.documentCurrencyCode,
            explanation: "",
            itemType: {recordId: 2, itemName: "HİZMET"},
            kdvPurchase: 1,
            kdvSell: 1,
            gvStoppagePurchase: 0,
            gvStoppageSell: 0,
            name: option.value,
            otv: 0,
            recordId: null,
            stockGroup: 1,
        };
        this.setState({stock: stock, stockModal: true, isCreate: false});
    }

    setStocks(stock, isSetParent) {
        this.setState({stockModal: false});
    }

    async listStocks(){
        let stocksList= await listStocksFromVoucherModal( this.state.stoppagePercentage, 20);
        this.setState({stocksList});
    }

    render() {
        let {
            amount,
            hasStoppage,
            calculateType,
            stoppagePercentage,
            kdvPercentage,
            net,
            kdvAmount,
            tahsilEdilen,
            stoppageAmount,
            itemName,
            brut,
            damgaVergisiPercentage,
            damgaVergisiAmount
        }= this.state;
        return (
            <div>
                <DefaultModal disabled={this.state.btnDisabled}
                              size="lg"
                              isOpen={this.props.voucherModal}
                              title="Serbest Meslek Makbuzu Hesaplama"
                              confirmBtnText="Hesapla ve Uygula"
                              cancelBtnText="Kapat"
                              onConfirm={()=>this.setState({btnDisabled:false}, () => {this.calculate(true)})}
                              onCancel={(e)=>this.setState({btnDisabled:false}, () => {this.props.toggleModal(false);})}>
                    <Row style={{paddingLeft:0, margin:"0px"}} className="baseDashboard">
                        <React.Fragment>
                            <Col sm={6} className="">
                                <label sm={12} style={{fontSize:14, fontWeight:"bold" , paddingBottom:"5px"}}>Makbuz Hesapla</label>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Row sm={12}>
                                            <Col sm={1}><input type="checkbox"
                                                               checked={!this.state.isManual}
                                                               style={{marginLeft:"5px"}}
                                                               onChange={(e)=>this.switchManualItemName(e)}/>
                                            </Col>
                                            <Col sm={8}>
                                                <Label  style={{marginLeft:"-10px"}}>Kayıtlı Hizmetlerden Getir</Label>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={10} style={{fontWeight:"bold"}}>Ücretin Ne için Alındığı: *</Label>
                                        <Col sm={12}>
                                            {this.state.isManual
                                                ?
                                                <Input id="itemName" value={itemName} onChange={(e) => this.onChange({
                                                    value: e.target.value,
                                                    name: "itemName"
                                                })}/>
                                                :
                                                <Select
                                                    id="itemName"
                                                    clearable={false}
                                                    searchable={true}
                                                    disabled={false}
                                                    className="select-control"
                                                    value={{
                                                        value: itemName,
                                                        label: itemName
                                                    }}
                                                    placeholder="Seçiniz..."
                                                    onChange={(e) => this.onStockChange(e)}
                                                    options={this.state.stocksList && this.state.stocksList.result && this.state.stocksList.result}
                                                />
                                            }
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={6} style={{fontWeight:"bold"}}>Stopajlı / Stopajsız: *</Label>
                                        <Col sm={12}>
                                            <Select
                                                clearable={false}
                                                searchable={false}
                                                disabled={false}
                                                className="select-control"
                                                value={hasStoppage}
                                                placeholder="Seçiniz..."
                                                onChange={e => this.onChange({
                                                    value: e.value,
                                                    name: "hasStoppage"
                                                })}
                                                options={[{value:0,label:"Stopajsız"},{value:1,label:"Stopajlı"}]}
                                            />
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={6} style={{fontWeight:"bold"}}>Hesaplama Tipi: *</Label>
                                        <Col sm={12}>
                                            <Select
                                                clearable={false}
                                                searchable={false}
                                                disabled={false}
                                                className="select-control"
                                                value={calculateType}
                                                placeholder="Seçiniz..."
                                                onChange={e => this.onChange({
                                                    value: e.value,
                                                    name: "calculateType"
                                                })}
                                                options={
                                                    [
                                                        {value: 0, label: "Brütten Hesaplama"},
                                                        {value: 1, label: "Netten Hesaplama"},
                                                        {value: 2, label: "Tahsil Edilenden Hesaplama"},
                                                        {value: 3, label: "KDV ve Stopaj Dahil"},
                                                        {value: 4, label: "KDV Dahil Stopaj Hariç"},
                                                        {value: 5, label: "KDV ve Stopaj Hariç"},
                                                        {value: 6, label: "KDV Hariç Stopaj Dahil"}
                                                    ]
                                                }
                                            />
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={6} style={{fontWeight:"bold"}}>Stopaj Oranı: *</Label>
                                        <Col sm={12}>
                                            <Select
                                                clearable={false}
                                                searchable={false}
                                                disabled={true}
                                                className="select-control"
                                                value={stoppagePercentage}
                                                placeholder="Seçiniz..."
                                                onChange={e => this.onChange({
                                                    value: e.value,
                                                    name: "stoppagePercentage"
                                                })}
                                                options={[{value:0,label:0},{value:20,label:20}]}
                                            />
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={6} style={{fontWeight:"bold"}}>KDV Oranı: *</Label>
                                        <Col sm={12}>
                                            <Select
                                                clearable={false}
                                                searchable={false}
                                                disabled={false}
                                                className="select-control"
                                                value={(kdvPercentage===null || kdvPercentage===undefined) ? 0 : kdvPercentage}
                                                placeholder="Seçiniz..."
                                                onChange={e => this.onChange({
                                                    value: e.value,
                                                    name: "kdvPercentage"
                                                })}
                                                options={[{value:0,label:0},
                                                    {value:1,label:1},
                                                    {value:8,label:8},
                                                    {value:10,label:10},
                                                    {value:18,label:18},
                                                    {value:20,label:20}
                                                ]}
                                            />
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={6} style={{fontWeight:"bold"}}>Tutar *</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="amount"
                                                          value={amount}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          decimalScale={9}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "amount"
                                                          })}
                                                          className="form-control"/>
                                            {this.validateMessage('amount') !== "" &&
                                            <UncontrolledTooltip placement="right"
                                                                 target={'amount'}
                                                                 delay={0}>
                                                {this.validateMessage('amount')}
                                            </UncontrolledTooltip>}
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={1} style={{fontWeight:"bold"}}>
                                            <input type="checkbox"
                                                   checked={this.state.checked}
                                                   style={{marginLeft:"5px"}}
                                                   onChange={this.switchDamgaVergisi}/>
                                        </Label>
                                        <Col sm={11} style={{display:'inline'}}>
                                            <Label  style={{marginLeft:"-10px"}}>Damga Vergisi eklensin mi?</Label>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                {this.state.checked &&
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={12} style={{fontWeight:"bold"}}>Damga Vergisi Oranı(Binde):</Label>
                                        <Col sm={12}>
                                            <NumberFormat id="damgaVergisiPercentage"
                                                          value={damgaVergisiPercentage}
                                                          decimalScale={2}
                                                          fixedDecimalScale={true}
                                                          disabled={!this.state.checked}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "damgaVergisiPercentage"
                                                          })}
                                                          className="form-control"/>
                                            {this.validateMessage('damgaVergisiPercentage') !== "" &&
                                            <UncontrolledTooltip placement="right"
                                                                 target={'damgaVergisiPercentage'}
                                                                 delay={0}>
                                                {this.validateMessage('damgaVergisiPercentage')}
                                            </UncontrolledTooltip>}
                                        </Col>
                                    </FormGroup>
                                </Col>
                                }
                                <Col sm={12}>
                                    <Row style={{margin:"0px"}}>
                                        <Col sm={6}>
                                            <Button color="default" size="sm" block onClick={this.clean}>Temizle</Button>
                                        </Col>
                                        <Col sm={6}>
                                            <Button color="info" size="sm" block onClick={()=>this.calculate(false)}>Hesapla</Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Col>
                            <hr></hr>
                            <Col sm={6} className="row">
                                <label sm={12} style={{fontSize:14,fontWeight:"bold", paddingBottom:"5px"}}>Hesaplama Sonucu</label>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={5} style={{fontWeight:"bold"}}>Brüt: </Label>
                                        <Col sm={12}>
                                            <NumberFormat value={brut}
                                                          decimalScale={2}
                                                          fixedDecimalScale={true}
                                                          disabled={!this.state.isManualResult}
                                                          suffix={this.props.suffix}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "brut"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={8} style={{fontWeight:"bold"}}>Stopaj Oranı: </Label>
                                        <Col sm={12}>
                                            <NumberFormat value={stoppagePercentage}
                                                          decimalScale={2}
                                                          fixedDecimalScale={true}
                                                          disabled={!this.state.isManualResult}
                                                          suffix={"%"}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "stoppagePercentage"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={8} style={{fontWeight:"bold"}}>Stopaj Tutarı: </Label>
                                        <Col sm={12}>
                                            <NumberFormat value={stoppageAmount}
                                                          decimalScale={2}
                                                          fixedDecimalScale={true}
                                                          disabled={!this.state.isManualResult}
                                                          suffix={this.props.suffix}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "stoppageAmount"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={8} style={{fontWeight:"bold"}}>Net: </Label>
                                        <Col sm={12}>
                                            <NumberFormat value={net}
                                                          decimalScale={2}
                                                          fixedDecimalScale={true}
                                                          disabled={true}
                                                          suffix={this.props.suffix}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "net"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={8} style={{fontWeight:"bold"}}>KDV Oranı: </Label>
                                        <Col sm={12}>
                                            <NumberFormat value={kdvPercentage}
                                                          decimalScale={2}
                                                          fixedDecimalScale={true}
                                                          disabled={!this.state.isManualResult}
                                                          suffix={"%"}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "kdvPercentage"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={8} style={{fontWeight:"bold"}}>KDV Tutarı: </Label>
                                        <Col sm={12}>
                                            <NumberFormat value={kdvAmount}
                                                          decimalScale={2}
                                                          fixedDecimalScale={true}
                                                          disabled={!this.state.isManualResult}
                                                          suffix={this.props.suffix}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "kdvAmount"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                {this.state.checked &&
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={8} style={{fontWeight:"bold"}}>Damga Vergisi Tutarı: </Label>
                                        <Col sm={12}>
                                            <NumberFormat value={damgaVergisiAmount}
                                                          decimalScale={2}
                                                          fixedDecimalScale={true}
                                                          disabled={!this.state.isManualResult}
                                                          suffix={this.props.suffix}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "damgaVergisiAmount"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                }
                                <Col sm={12}>
                                    <FormGroup>
                                        <Label sm={8} style={{fontWeight:"bold"}}>Tahsil Edilen: </Label>
                                        <Col sm={12}>
                                            <NumberFormat value={tahsilEdilen}
                                                          decimalScale={3}
                                                          fixedDecimalScale={true}
                                                          disabled={!this.state.isManualResult}
                                                          suffix={this.props.suffix}
                                                          allowNegative={false}
                                                          isNumericString={true}
                                                          allowEmptyFormatting={false}
                                                          thousandSeparator={'.'}
                                                          decimalSeparator={','}
                                                          displayType="input"
                                                          renderText={value => {
                                                              value.replace(/\./g, ',')
                                                          }}
                                                          onValueChange={(e) => this.onChange({
                                                              value: e.value,
                                                              name: "tahsilEdilen"
                                                          })}
                                                          className="form-control"/>
                                        </Col>
                                    </FormGroup>
                                </Col>
                            </Col>
                        </React.Fragment>
                    </Row>
                </DefaultModal>
                {this.state.stockModal &&
                <StockModal listener={this.setStocks}
                            modal={this.state.stockModal}
                            stock={this.state.stock}
                            isCreate={this.state.isCreate}
                            currencyCodes={this.props.currencyCodes}
                            unitCodes={this.props.unitCodes}
                            exemptions={[]}
                            type="voucher"
                            withholdingTypes={this.props.withholdingTypes}
                />
                }
            </div>
        )
    }
}

export default VoucherModal;